import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  getNewCodeButtonRoot: {
    marginBottom: 24,
  },
}));
